import BvInlineEdit from 'volta/components/bv-inline-edit';
import BvTag from 'volta/components/bv-tag';
import BaseCell from './base-cell';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellTagsCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellTagsCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='tags-cell'
    as |baseCell|
  >
    {{#if baseCell.value.length}}
      <BvInlineEdit @hideDefaultActions={{true}} @withDisplay={{true}} @stopPropagation={{true}}>
        <:default>
          {{#each baseCell.value as |tag|}}
            <BvTag @text={{tag}} @size='sm' class='u-my-1 u-mr-1' />
          {{/each}}
        </:default>
      </BvInlineEdit>
    {{/if}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellTagsCellSignature>;

export default CellTagsCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::TagsCell': typeof CellTagsCellComponent;
    'cell/tags-cell': typeof CellTagsCellComponent;
  }
}
